
export const LANG_BG = 'bulgarian';
export const LANG_EN = 'english';

export const SHORT_BG = 'BG';
export const SHORT_EN = 'EN';

export const DEFAULT_LANGUAGE = LANG_BG;

export const STORE_SELECTED_LANGUAGE = 'selectedLanguage';


export const SIGNALIR_ROUTE = '/weather/signalr';
export const SIGNALIR_EVENT_NEWWEATHERDATA = 'newWeatherData';

export const SSE_ROUTE = '/weather/sse';


